import { createContext, useContext } from "react";

interface TrashDeleteModalContextValue {
  /** Opens the shared per-table "Delete forever" confirmation modal for this asset id. */
  requestDeleteForever: (assetId: string) => void;
}

// A row can't safely render its own modal (it lives inside the DataTable's
// collection), so it requests one via context; AssetTable hosts a single instance.
export const TrashDeleteModalContext = createContext<
  TrashDeleteModalContextValue | undefined
>(undefined);

export function useTrashDeleteModalContext(): TrashDeleteModalContextValue {
  const context = useContext(TrashDeleteModalContext);
  // Falls back to a no-op outside a provider (e.g. isolated unit tests) so
  // AssetRow doesn't need to know whether it's under AssetTable.
  return context ?? { requestDeleteForever: () => {} };
}
